module.exports = __webpack_public_path__ + "img/mindscapcourse.d02a06ae.svg";